import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['details', 'detailTemplate', 'identifierInput', 'quantityInput']

  connect() {
    this.changeQuantity()
  }

  changeQuantity() {
    const currentQuantity = this.quantityInputTarget.valueAsNumber || 0
    const currentRecords  = this.detailsTarget.querySelectorAll('.product-delivery-item__detail').length
    const difference      = currentQuantity - currentRecords

    if (difference > 0) {
      for (let i = 0; i < difference; i++) {
        const template = this.detailTemplateTarget.innerHTML.replace(/NEW_RECORD/g, currentRecords + i)
        this.detailsTarget.insertAdjacentHTML('beforeend', template)
      }
    } else if (difference < 0) {
      const recordsToRemove = -difference
      const details = this.detailsTarget.querySelectorAll('.product-delivery-item__detail')

      for (let i = 0; i < recordsToRemove && i < details.length; i++) {
        details[details.length - 1 - i].remove()
      }
    }

    this.handleIdentifierTargets()
  }

  handleIdentifierTargets() {
    this.identifierInputTargets.forEach(identifierInput => {
      identifierInput.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      })
    })
  }
}
